/* eslint-disable no-param-reassign */
const getManifest = (system: string): string => {
  const manifest = {
    short_name: '',
    name: '',
    icons: [
      {
        src: '',
        sizes: '64x64 32x32 24x24 16x16',
        type: 'image/x-icon',
      },
      {
        src: '',
        type: 'image/png',
        sizes: '192x192',
      },
      {
        src: '',
        type: 'image/png',
        sizes: '512x512',
      },
    ],
    display: 'standalone',
    theme_color: '#000000',
    background_color: '#ffffff',
  };
  switch (system) {
    case 'legalone-analytics': {
      manifest.short_name = 'Legal One Analytics';
      manifest.name = 'Legal One Analytics, seu assistente de BI Jurídico';
      manifest.icons.forEach((icon) => {
        icon.src = `${document.location.origin}/icon-thomson.svg`;
      });
      break;
    }
    case 'benner-metrics': {
      manifest.short_name = 'Benner Metrics';
      manifest.name = 'Benner, seu assistente de BI Jurídico';
      manifest.icons.forEach((icon) => {
        icon.src = `${document.location.origin}/fav_benner.svg`;
      });
      break;
    }
    default: {
      manifest.short_name = 'Legal Metrics';
      manifest.name = 'Legal Metrics, seu assistente de BI Jurídico';
      manifest.icons.forEach((icon) => {
        icon.src = `${document.location.origin}/logo.svg`;
      });
      break;
    }
  }
  return JSON.stringify(manifest);
};

export default getManifest;
